import { Button } from "@/components/ui/baseUi/button"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { useCurrentBoxId } from "@/modules/core/store/useCurrentSpaceManagerStore"
import { word } from "@/modules/core/utils/i18n"
import { ProfileForm } from "@/modules/profile/myProfile/components/profileForm"
import { ProfilePrograms } from "@/modules/profile/myProfile/components/profilePrograms"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { useUser } from "@/modules/users/hooks/useUser"
import { Config } from "@modules/config"
import { DebugDialog } from "@modules/debug/debugDialog"
import { useDebug } from "@modules/debug/useDebug"
import { ProfileAvatarForm } from "@modules/profile/myProfile/components/profileAvatarForm"
import { PublicProfileInfoResume } from "@modules/profile/publicProfile/components/publicProfileInfoResume"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export function ProfilePage() {
  const user = useUser()
  const boxId = useCurrentBoxId()
  const { visible, setVisible, onDebugClick } = useDebug()
  const { sidebarNavigateTo } = useSidebar()

  const onOpenMyProfile = () => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <PublicProfileInfoResume userId={user.id} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
    })
  }

  return (
    <div className="flex h-full w-full flex-col gap-6 p-6">
      <div className="mx-auto flex w-full max-w-380 flex-col justify-center gap-8 lg:h-full lg:flex-row">
        {/* Left column */}
        <div className="flex grow flex-col gap-4 lg:max-w-[50%]">
          <ProfileAvatarForm user={user} />
          <Button
            variant="underline"
            size="lg"
            onClick={onOpenMyProfile}
            className="self-center"
            data-testid="see-public-profile"
          >
            {word("profile.form.seePublicProfile")}
          </Button>

          <ProfilePrograms openProgramDisabled={!!boxId} />
        </div>

        {/* Right column */}
        <div className="flex grow lg:max-w-[50%]">
          <ProfileForm user={user} />
        </div>
      </div>

      {/* Version information */}
      <div className="mx-auto flex flex-col items-center lg:mx-0" onClick={onDebugClick}>
        {Config.ENV !== "prod" ? Config.ENV + "-" : ""}
        {__VERSION__}-{__GIT_HASH__}
      </div>
      <DebugDialog visible={visible} setVisible={setVisible} />
    </div>
  )
}
